import React from "react";

function Glimpse() {
  return (
    <>
      <div className="home-blog-two-area default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Latest Blog</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Glimpse of Our White Label Crypto Wallet
                </h2>
                <p>
                  Take a look at the design & feel of our white label crypto
                  wallet! It could be designed, customized & crafted as you
                  want.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="blog-style-two-box">
            <img src="https://xeertechnology.com/assets/img/wallet/glimpse-of-our-white-label-crypto-wallet.png" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Glimpse;
